import Answer from './Answer.component';

export default Answer;
